<template>
<div id="app" v-if="!isLoading">
  <GDheader></GDheader>
  <router-view />
  <GdBizFooter></GdBizFooter>
</div>
</template>

<script>
import GDheader from "./components/gd-header.vue"
import GdBizFooter from "../components/GdBizFooter.vue"
import {
  areaJsonName
} from '@/assets/utils/areaJson.js'
import {
  outnetConfig
} from '@/assets/utils/controlApi'
export default {
  data() {
    return {
        isLoading: true
    }
  },
  components: {
    GDheader,
    GdBizFooter
  },
  methods: {
    //获取外网参数配置
    getOutnetConfig(key) {
      return new Promise((resolve) => {
        outnetConfig({
          key: key
        }).then(res => {
          if (res.status == '200') {
            res.data.forEach(item => {
              sessionStorage.setItem(item.key, item.value);
            })
            let crossAreaName = sessionStorage.getItem("crossAreaName");
            sessionStorage.setItem("areaNameChinese", areaJsonName[crossAreaName]); //将地区标识转为中文 湛江
            this.isLoading = false;
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    }
  },
  created() {
    this.getOutnetConfig("crossAreaName;AGING_KEY");
  }
}
</script>

<style lang="scss">
#app {
  font-family: PingFangSC-Semibold, PingFangSC-Medium, PingFang SC;
  font-size: 16px;
}
</style>
